// extracted by mini-css-extract-plugin
export default {"logo":"BrandLogoLink-logo-mN_"};